import React from "react";
import styled, { keyframes } from "styled-components";

export const Loader = props => {
  return (
    <LoaderContainer>
      <LoaderInner />
    </LoaderContainer>
  );
};

const rotate360 = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;
const LoaderContainer = styled.div`
  width: 100%;
  margin: 1rem 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const LoaderInner = styled.div`
  width: 60px;
  height: 60px;

  border-radius: 100%;

  border-top: 3px solid #33cc99;
  border-right: 3px solid transparent;
  animation: ${rotate360} 1s linear infinite;
`;
